export const programs = {
  title: 'Ипотечные программы с господдержкой',
  elements: [
    {
      name: 'Семейная ипотека',
      rate: 'До 6%',
      whoCanGet: 'Семьи с одним ребенком младше 6 лет, с ребенком-инвалидом, или с двумя несовершеннолетними детьми',
      creditFor:
        'Покупка недвижимости на первичном рынке, строительство дома, рефинансирование взятой ранее ипотеки на первичном рынке',
      conditions:
        'Заключение ипотечного договора до конца 2030 года, минимальный взнос 20%. Есть ограничение по сумме кредита по льготной ставке',
    },
    {
      name: 'Дальневосточная и арктическая ипотека',
      rate: 'До 2%',
      whoCanGet:
        'Молодые семьи и одинокие родители, живущие в этих регионах, а также работники определенных социальных групп',
      creditFor: 'Приобретение жилья от застройщика, строительство дома, вторичное жилье в некоторых регионах',
      conditions: 'Заключение договора до конца 2030 года, есть ограничение по сумме кредита',
    },
    {
      name: 'Сельская ипотека',
      rate: 'От 0,1 до 3%',
      whoCanGet: 'Граждане РФ',
      creditFor: 'Покупка или строительство жилья в сельской местности',
      conditions: 'Срок до 25 лет, сумма кредита до 6–9 млн ₽',
    },
  ],
};
